import { render } from "./TermsofService.vue?vue&type=template&id=634fce52&scoped=true&ts=true"
import script from "./TermsofService.vue?vue&type=script&setup=true&lang=ts"
export * from "./TermsofService.vue?vue&type=script&setup=true&lang=ts"

import "./TermsofService.vue?vue&type=style&index=0&id=634fce52&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3191932516/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-634fce52"],['__file',"src/components/scan/salesnote/kdp/TermsofService.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "634fce52"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('634fce52', __exports__)) {
    console.log('reload')
    api.reload('634fce52', __exports__)
  }
  
  module.hot.accept("./TermsofService.vue?vue&type=template&id=634fce52&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('634fce52', render)
  })

}


export default __exports__